<template>
  <MainLayoutV2 section="post">
    <div id="post_detail_container">
      <div class="post_detail">
        <a class="subtitle-2 post-back d-flex align-items-center"
           @click="nav_to_news">
          Back to News
        </a>

        <h1 class="mb-3">{{ post.title }}</h1>

        <div class="post-item-detail">
          <p class="post-item-detail-date body-2 mb-3">{{parsed_date.toLocaleString('default', { month: 'long' })}} {{parsed_date.getDate()}}</p>

          <div class="post-item-detail-image mb-3">
            <img :src="post_img_page(post)">
          </div>

          <div class="post-item-post-container mb-2 pb-5">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </MainLayoutV2>      
</template>

<script>
import MainLayoutV2  from "@/components/V2/layout/MainLayoutV2"
import HasPost     from "@/mixins/HasPost"

export default {
  name: "PostV2",

  mixins: [
    HasPost
  ],

  components: {
    MainLayoutV2,
  },

  methods: {
    nav_to_news: function () {
      this.$router.push("/news")
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/custom.scss";
#post_detail_container{
  padding-top: 155px;
  color: $white;

  @media screen and (max-width: 767px) {
    padding-top: 125px;
  }
}

#post_detail_container {
  max-width: 912px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;
  font-family: Alliance No2;
}

.post-back {
  cursor: pointer;
  margin-bottom: 44px;
  color: $white;

  @media screen and (max-width: 767px) {
    margin-bottom: 30px;
  }

  &:before {
    content: url("~@/assets/imgs/new_arrow_left.svg");
    width: 24px;
    height: 24px;
    margin-right: 11px;
  }
}

.post-back:hover{
  color: $white;
  text-decoration: none;
}

.post_detail h1{
  font-family: Bricolage Grotesque ExtraBold;
}

.post-item-detail {
  &-image {
    height: 500px;
    width: 864px;
    border-radius: 4px;
    background: $grey-1;

    img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }

    @media screen and (max-width: 912px) {
      width: auto; 
      height: auto;
      margin-left: -24px;
      margin-right: -24px;
    }
  }
}

.post-item-post-container {
  .subsection {
    padding: 15px;
  }

  img {
    max-width: 100%;
    display: block;
    margin: auto;
  }

  .img-caption {
    text-align: center;
    margin-bottom: 1.25rem;
    font-style: italic;
  }

  .space-even{
    display: flex;
    justify-content: space-evenly;
  }

  table, th, td{
    border: 1px solid;
  }

  th, td{
    padding: 5px;
  }

  hr{
    border-color: white;
  }

  pre{
    background-color: rgb(225, 225, 225);
  }
}

.post-item-share {
  padding-bottom: 25px;

  @media screen and (max-width: 767px) {
    padding-bottom: 10px;
  }
}
</style>
